import { apiFetchWithMeta } from './client.js'

export interface LogRun {
  id: string
  kind: string
  timestamp: string
  sizeBytes: number
  fileCount: number
}

export const fetchLogRuns = (): Promise<LogRun[]> =>
  apiFetchWithMeta<LogRun[]>('/api/v2/agent/logs').then((r) => r.data)

// apiFetchWithMeta, not apiFetch: list responses must go through the
// meta-aware client so a later move to a paginated envelope does not silently
// truncate results. Mirrors fetchLogRuns above; `meta` is optional.
export const fetchLogFiles = (runId: string): Promise<string[]> =>
  apiFetchWithMeta<string[]>(`/api/v2/agent/logs/${encodeURIComponent(runId)}/files`).then(
    (r) => r.data,
  )

export function streamLogFile(runId: string, filePath: string): string {
  return `/api/v2/agent/logs/${encodeURIComponent(runId)}/${encodeURIComponent(filePath)}`
}
